import moment from "moment";

/**
 * Formats move-in / move-out style dates from the API for display.
 * Values are often ISO strings at UTC midnight (e.g. 2024-03-15T00:00:00.000Z). Using
 * `new Date(...).toLocaleDateString()` interprets that instant in local time, which shifts
 * the calendar day backward for US timezones — so we format using the UTC calendar date.
 *
 * @param {string|Date|number} value
 * @returns {string}
 */
export function formatAccountCalendarDate(value) {
  if (value == null || value === "") return "";
  const m = moment.utc(value);
  if (!m.isValid()) {
    return new Date(value).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  }
  return m.format("MMM D, YYYY");
}
